var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreenBlind = function SvgGreenBlind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 28,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2A12 12 0 0 0 0 14a12 12 0 0 0 12 12 12 12 0 0 0 8.69-3.764A13.92 13.92 0 0 1 18 14c0-3.086 1.006-5.94 2.703-8.256A12 12 0 0 0 12 2m9.996 5.363A11.96 11.96 0 0 0 20 14c0 2.452.733 4.73 1.99 6.627A12 12 0 0 0 24 14a12 12 0 0 0-2.004-6.637",
    style: {
      fill: "#cd4b5b"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 12,
    fill: "#efa127"
  })));
};
export { SvgGreenBlind as ReactComponent };
export default __webpack_public_path__ + "2132780c16e6c5517292e573e3cc4f7b.svg";